<template>
  <v-dialog :value="dialog" @input="$emit('update:dialog', $event)" max-width="380">
    <v-card class="rounded-xl">
      <v-card-title class="subtitle-1 font-weight-bold">
        Categoría de: {{ nodo?.name }}
      </v-card-title>

      <v-card-text class="pb-0">
        <v-list dense>
          <v-list-item-group :value="actual" mandatory @change="asignar">
            <v-list-item :value="null">
              <span class="color-swatch sin-categoria mr-3"></span>
              <v-list-item-title class="grey--text">Sin categoría</v-list-item-title>
            </v-list-item>
            <v-list-item v-for="cat in categorias" :key="cat.id" :value="cat.id">
              <SimboloCategoria :icono="cat.icono" :color="cat.color" :tamano="18" class="mr-3" />
              <v-list-item-title>{{ cat.nombre }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card-text>

      <v-card-actions>
        <v-btn v-if="puedeGestionar" text small color="primary" class="text-none" @click="$emit('gestionar')">
          <v-icon left small>mdi-palette-outline</v-icon> Gestionar categorías
        </v-btn>
        <v-spacer />
        <v-btn text @click="$emit('update:dialog', false)">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import SimboloCategoria from "@/components/utils/SimboloCategoria.vue";

export default {
  name: "DialogAsignarCategoria",
  components: { SimboloCategoria },
  props: {
    dialog: { type: Boolean, default: false },
    nodo: { type: Object, default: null },
    puedeGestionar: { type: Boolean, default: false },
  },
  computed: {
    ...mapState("armarios", ["categorias", "categoriaPorArmario"]),
    actual() {
      return (this.nodo && this.categoriaPorArmario[this.nodo.id]) || null;
    },
  },
  methods: {
    asignar(id_categoria) {
      if ((id_categoria ?? null) === this.actual) return;
      this.$emit("asignar", { nodo: this.nodo, id_categoria: id_categoria ?? null });
    },
  },
};
</script>

<style scoped>
.color-swatch {
  display: inline-block;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
}
.sin-categoria {
  background: repeating-linear-gradient(45deg, #fff, #fff 3px, #e0e0e0 3px, #e0e0e0 6px);
}
</style>
